import { alpha } from '@mui/material/styles';
import palette from '../palette';

export default alpha(palette.primary.main, 0.3);
